import React, { useCallback, useEffect, useState } from 'react'
import { AutoColumn } from '../../../../components/Column'
import CategoryList from '../../data/NFTCategoryList'
import INFTCategory from '../../models/INFTCategory'
import NFTCategoryButton from '../../components/NFTCategoryButton'
import { getNotInSalesNFTList, getSalesNFTList } from '../../../../services/NFTMarketPlace/Graphquery'
import Loader from '../../../../components/Loader'
import INFTSalesList, { INFTMarketPlaceSaleList } from '../../models/INFTSalesList'
import { useActiveWeb3React } from '../../../../hooks'
import { ChainId } from '@yetiswap/sdk'
import NFTMarketPlaceMenu from '../../components/NFTMarketPlaceMenu'
import NFTMarketItem from './components/NFTMarketItem'
import NFTPagination from '../../components/NFTPagination'
import { MARKET_PLACE } from '../../data/NFTMarketPerPages'
import { CategoryListWrapper, PageWrapper, FilterListWrapper, ConnectWarning } from './styled'
import NFTCurrencyDropdown from '../../components/NFTCurrencyDropdown'
import NFTDropdown from '../../components/NFTDropdown'
import { NFTPerPage, NFTSortingList } from '../../data/NFTFilterOptions'

export default function NFTMarketPlace() {
  const { chainId, account } = useActiveWeb3React()
  /*NFT SALES LIST START*/
  const [NFTList, setNFTList] = useState<INFTMarketPlaceSaleList>({
    data: [],
    count: 0
  })
  const [listLoading, setListLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState<number>(0)
  const [skipItems, setSkipItems] = useState<number>(0)
  const [categoryId, setCategoryId] = useState<number | null>(null)
  const [notInCount, setNotInCount] = useState<number>(0)
  const [nftCurrency, setNftCurrency] = useState('ALL')
  const [nftSort, setNftSort] = useState('NewestItems')
  const [nftPerPage, setNftPerPage] = useState(MARKET_PLACE.HOME)

  const getSalesNFTItems = useCallback(
    (skipItem?: number, categoryItem?: number | null, sortItems?: string, perPage?: number, currency?: string) => {
      getNotInSalesNFTList(categoryItem ? { categoryId: categoryItem } : categoryId ? { categoryId } : undefined).then(
        res => {
          setNotInCount(res)
        }
      )
      getSalesNFTList(
        categoryItem ? { categoryId: categoryItem } : categoryId ? { categoryId } : undefined,
        skipItem ? skipItem : skipItems,
        sortItems,
        perPage,
        currency
      )
        .then((response: INFTMarketPlaceSaleList) => {
          setNFTList(response)
          setListLoading(false)
        })
        .catch((err: any) => {
          setListLoading(false)
        })
    },
    [categoryId, skipItems]
  )

  useEffect(() => {
    getSalesNFTItems(skipItems, categoryId, nftSort, nftPerPage, nftCurrency)
  }, [getSalesNFTItems, categoryId, skipItems, , nftSort, nftPerPage, nftCurrency])
  /*NFT SALES LIST END*/

  function resetPagination() {
    setCurrentPage(0)
    setSkipItems(0)
  }

  /*CATEGORY FILTER START*/
  function filterNFTListCategory(itemId: number | null) {
    setListLoading(true)
    setCategoryId(itemId)
    resetPagination()
  }
  /*CATEGORY FILTER END*/

  function onPageChange(seletedItem: any) {
    const skip: number = seletedItem.selected * nftPerPage
    setCurrentPage(seletedItem.selected)
    setSkipItems(skip)
  }

  function getList() {
    return listLoading ? (
      <div className="loader">
        <Loader />
      </div>
    ) : (
      <>
        <div className="nft-card-list">
          {NFTList.data.map((item: INFTSalesList) => (
            <NFTMarketItem
              key={`${item.id}_${item.tokenContract}_MARKET`}
              item={item}
              getSalesNFTItems={getSalesNFTItems}
              account={account ? account : ''}
            />
          ))}
        </div>
        <NFTPagination
          pageCount={NFTList.count - notInCount}
          perPage={nftPerPage}
          page={currentPage}
          pageChange={onPageChange}
        />
      </>
    )
  }

  return (
    <PageWrapper>
      <AutoColumn style={{ width: '100%', maxWidth: '1024' }}>
        <NFTMarketPlaceMenu />
        <CategoryListWrapper>
          {CategoryList.map((item: INFTCategory) => (
            <NFTCategoryButton
              active={categoryId === item.id}
              key={item.id ? `${item.id}_CATEGORY` : 'ALL_CATEGORY'}
              text={item.name}
              onClick={() => filterNFTListCategory(item.id)}
            />
          ))}
        </CategoryListWrapper>
        <FilterListWrapper>
          <div className="currency-filter">
            <div className="currency-filter-dropdown filterDropDown">
              <NFTCurrencyDropdown
                allOption={true}
                onChange={(val: any) => {
                  setNftCurrency(val)
                  resetPagination()
                }}
              />
            </div>
          </div>
          <div className="items-filter">
            <div className="sort-dropdown filterDropDown">
              <NFTDropdown
                defaultValue={nftSort}
                onChange={(val: any) => {
                  setNftSort(val)
                  resetPagination()
                }}
                options={NFTSortingList}
              />
            </div>
            <div className="per-page-dropdown filterDropDown">
              <NFTDropdown
                defaultValue={nftPerPage}
                onChange={(val: any) => {
                  setNftPerPage(val)
                  resetPagination()
                }}
                options={NFTPerPage}
              />
            </div>
          </div>
        </FilterListWrapper>
        {chainId !== ChainId.FUJI ? (
          <ConnectWarning>
            PLEASE CONNECT TO <br /> AVALANCHE FUJI C-CHAIN
          </ConnectWarning>
        ) : (
          getList()
        )}
      </AutoColumn>
    </PageWrapper>
  )
}
